export const theme = {
  token: {
    colorPrimary: '#1890ff',
    colorInfo: '#1890ff',
    borderRadius: 8,
  },
};
